import 'react-intl-tel-input/dist/main.css';
import './styles.css';

import { forwardRef, useRef } from 'react';

import IntlTelInput from 'react-intl-tel-input';

interface WePhoneInputProps {
  value: string;
  onChange: (value: string) => void;
}

const WePhoneInput = forwardRef(
  ({ value, onChange }: WePhoneInputProps, ref) => {
    const telInputRef = useRef<HTMLInputElement | null>(null);

    const setCursorToEnd = () => {
      const input = telInputRef.current;
      if (input) {
        input.focus();
        requestAnimationFrame(() => {
          const length = input.value.length;
          input.setSelectionRange(length, length);
        });
      }
    };

    return (
      <div>
        <IntlTelInput
          preferredCountries={['de']}
          value={value}
          onPhoneNumberChange={(isValid, num, countryData, fullNum) => {
            onChange(fullNum.replace(/\s+/g, ''));
            setCursorToEnd();
          }}
          ref={input => {
            telInputRef.current = input?.tel as HTMLInputElement | null;
          }}
          fieldId="phone"
        />
      </div>
    );
  }
);

WePhoneInput.displayName = 'WePhoneInput';

export default WePhoneInput;
